module.exports = __webpack_public_path__ + "img/2m.d74440cb.jpg";